import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase/config";

import LandingPage            from "./pages/LandingPage";
import AuthPage               from "./pages/AuthPage";
import CatalogoPublico        from "./pages/CatalogoPublico";
import Layout                 from "./components/Layout";

// Admin
import AdminDashboard         from "./components/admin/AdminDashboard";
import AdminProductos         from "./components/admin/AdminProductos";
import AdminCatalogo          from "./components/admin/AdminCatalogo";
import AdminCategorias        from "./components/admin/AdminCategorias";
import AdminGlobales          from "./components/admin/AdminGlobales";
import AdminUsuarios          from "./components/admin/AdminUsuarios";
import AdminCiclos            from "./components/admin/AdminCiclos";
import AdminPedidos           from "./components/admin/AdminPedidos";
import AdminDocumentos        from "./components/admin/AdminDocumentos";
import AdminProveedores       from "./components/admin/AdminProveedores";
import AdminPedidosProveedor  from "./components/admin/AdminPedidosProveedor";
import { AdminNotificaciones } from "./components/Notificaciones";

// Comprador
import CompradorCatalogo      from "./components/comprador/CompradorCatalogo";
import CompradorPedidos       from "./components/comprador/CompradorPedidos";
import CompradorAMedida       from "./components/comprador/CompradorAMedida";

// Vendedor
import { VendedorClientes, VendedorComisiones, VendedorPedidos } from "./components/vendedor/VendedorPanel";

const PH = ({ title }) => (
  <div style={{ padding:40, fontFamily:"'Outfit',sans-serif" }}>
    <div style={{ fontSize:28, color:"#1C1917", marginBottom:8, fontWeight:700 }}>{title}</div>
    <div style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:11, color:"#8C8078" }}>Próximamente.</div>
  </div>
);

function AppPanel() {
  const { profile } = useAuth();
  const [activeView, setActiveView] = useState(null);
  const [globales, setGlobales] = useState(null);

  useEffect(() => {
    getDoc(doc(db, "configuracion", "globales")).then(snap => {
      if (snap.exists()) setGlobales(snap.data());
    });
  }, []);

  useEffect(() => {
    if (!profile) return;
    const def = { admin:"dashboard", vendedor:"mis-clientes", comprador:"catalogo" };
    setActiveView(def[profile.rol] || "catalogo");
  }, [profile]);

  if (!activeView) return null;
  const rol = profile?.rol || "comprador";

  const renderView = () => {
    if (rol === "admin") {
      if (activeView === "dashboard")          return <AdminDashboard />;
      if (activeView === "productos")          return <AdminProductos globales={globales} />;
      if (activeView === "catalogo-pdf")       return <AdminCatalogo />;
      if (activeView === "categorias")         return <AdminCategorias />;
      if (activeView === "globales")           return <AdminGlobales onUpdate={setGlobales} />;
      if (activeView === "usuarios")           return <AdminUsuarios />;
      if (activeView === "ciclos")             return <AdminCiclos />;
      if (activeView === "pedidos")            return <AdminPedidos />;
      if (activeView === "documentos")         return <AdminDocumentos />;
      if (activeView === "proveedores")        return <AdminProveedores />;
      if (activeView === "pedidos-proveedor")  return <AdminPedidosProveedor />;
      if (activeView === "notificaciones")     return <AdminNotificaciones />;
    }
    if (rol === "vendedor") {
      if (activeView === "mis-clientes")  return <VendedorClientes />;
      if (activeView === "pedidos")       return <VendedorPedidos />;
      if (activeView === "comisiones")    return <VendedorComisiones />;
    }
    if (activeView === "catalogo")    return <CompradorCatalogo />;
    if (activeView === "mis-pedidos") return <CompradorPedidos />;
    if (activeView === "amedida")     return <CompradorAMedida />;
    return <PH title={activeView} />;
  };

  return (
    <Layout activeView={activeView} setActiveView={setActiveView}>
      {renderView()}
    </Layout>
  );
}

function AuthGate() {
  const { user } = useAuth();
  if (user) return <Navigate to="/app" />;
  return <AuthPage />;
}

function ProtectedRoute() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/auth" />;
  return <AppPanel />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"         element={<LandingPage />} />
          <Route path="/catalogo" element={<CatalogoPublico />} />
          <Route path="/auth"     element={<AuthGate />} />
          <Route path="/app"      element={<ProtectedRoute />} />
          <Route path="*"         element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
